import React from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import AdminPage from '../../components/admin/AdminPage';
import SectionCard from '../../components/admin/SectionCard';
import MetricCard from '../../components/admin/MetricCard';
import {
  MODULE_ACTIONS,
  ROLE_DESCRIPTIONS,
  ROLE_PERMISSION_MATRIX,
} from '../../config/permissions';

const RolesPermissionsPage = () => {
  const roles = Object.keys(ROLE_PERMISSION_MATRIX);
  const modules = Object.keys(MODULE_ACTIONS);

  return (
    <AdminPage
      title="Roles & Permissions"
      description="This matrix documents the current route and module access model used by the admin dashboard."
    >
      <Grid container spacing={2.5}>
        {roles.map((role) => (
          <Grid item xs={12} md={4} key={role}>
            <MetricCard
              label={role}
              value={String(
                Object.values(
                  ROLE_PERMISSION_MATRIX[role as keyof typeof ROLE_PERMISSION_MATRIX]
                ).filter(Boolean).length
              )}
              helperText={ROLE_DESCRIPTIONS[role as keyof typeof ROLE_DESCRIPTIONS]}
            />
          </Grid>
        ))}
      </Grid>

      <SectionCard
        title="Permission matrix"
        description="Route protection and action gating are driven from this shared matrix."
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Module</TableCell>
              {roles.map((role) => (
                <TableCell key={role}>{role}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {modules.map((moduleKey) => (
              <TableRow key={moduleKey}>
                <TableCell>
                  <Typography fontWeight={600} sx={{ textTransform: 'capitalize' }}>
                    {moduleKey}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {MODULE_ACTIONS[moduleKey as keyof typeof MODULE_ACTIONS].join(', ')}
                  </Typography>
                </TableCell>
                {roles.map((role) => (
                  <TableCell key={`${moduleKey}-${role}`}>
                    {ROLE_PERMISSION_MATRIX[role as keyof typeof ROLE_PERMISSION_MATRIX][
                      moduleKey as keyof typeof MODULE_ACTIONS
                    ]?.join(', ') || 'No access'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </SectionCard>
    </AdminPage>
  );
};

export default RolesPermissionsPage;
